import Plugin from "@ckeditor/ckeditor5-core/src/plugin"
import Widget from "@ckeditor/ckeditor5-widget/src/widget"
import {
  toWidget,
  toWidgetEditable,
} from "@ckeditor/ckeditor5-widget/src/utils"
import { enablePlaceholder } from "@ckeditor/ckeditor5-engine/src/view/placeholder"
import InlineAdvertisementCommand from "./inlineadvertisementcommand"

export default class InlineAdvertisementEditing extends Plugin {
  static get requires() {
    return [Widget]
  }

  init() {
    this.defineSchema()
    this.defineConverters()
    this.editor.commands.add(
      "insertInlineAdvertisement",
      new InlineAdvertisementCommand(this.editor)
    )
  }

  defineSchema() {
    const schema = this.editor.model.schema

    schema.register("inlineAdvertisementBox", {
      isObject: true,
      allowWhere: "$block",
    })
    schema.register("inlineAdvertisementLabel", {
      allowIn: "inlineAdvertisementBox",
      allowContentOf: "$block",
    })
    schema.register("inlineAdvertisementDescription", {
      isLimit: true,
      allowIn: "inlineAdvertisementBox",
      allowContentOf: "$block",
      allowAttributes: ["id"],
    })
    schema.register("inlineAdvertisementCustomScript", {
      isLimit: true,
      allowIn: "inlineAdvertisementBox",
      allowContentOf: "$block",
    })
  }

  defineConverters() {
    const conversion = this.editor.conversion

    // <inlineAdvertisementBox> converters
    conversion.for("upcast").elementToElement({
      model: "inlineAdvertisementBox",
      view: {
        name: "div",
        classes: "inline-advertisement-box",
      },
    })
    conversion.for("dataDowncast").elementToElement({
      model: "inlineAdvertisementBox",
      view: {
        name: "div",
        classes: "inline-advertisement-box",
      },
    })
    conversion.for("editingDowncast").elementToElement({
      model: "inlineAdvertisementBox",
      view: (modelElement, viewWriter) => {
        const div = viewWriter.createContainerElement("div", {
          class: "inline-advertisement-box",
        })
        return toWidget(div, viewWriter, { label: "inline advertisement box" })
      },
    })

    // <inlineAdvertisementLabel> converters
    conversion.elementToElement({
      model: "inlineAdvertisementLabel",
      view: {
        name: "label",
        classes: "inline-advertisement-label",
      },
    })

    // <inlineAdvertisementDescription> converters
    conversion
      .for("upcast")
      .elementToElement({
        model: "inlineAdvertisementDescription",
        view: {
          name: "h1",
          classes: "inline-advertisement-description",
        },
      })
      .attributeToAttribute({
        view: "id",
        model: "id",
      })
    conversion.for("dataDowncast").elementToElement({
      model: "inlineAdvertisementDescription",
      view: (modelElement, viewWriter) => {
        const h1 = viewWriter.createContainerElement("h1", {
          id: modelElement.getAttribute("id"),
          class: "inline-advertisement-description",
        })
        return toWidget(h1, viewWriter, { label: "inline advertisement box" })
      },
    })
    conversion.for("editingDowncast").elementToElement({
      model: "inlineAdvertisementDescription",
      view: (modelElement, viewWriter) => {
        // Note: You use a more specialized createEditableElement() method here.
        const h1 = viewWriter.createContainerElement("h1", {
          id: modelElement.getAttribute("id"),
          class: "inline-advertisement-description",
        })
        // const h1 = viewWriter.createContainerElement( 'h1', { class: 'inline-advertisement-description' } );
        return toWidget(h1, viewWriter)
      },
    })

    // <inlineAdvertisementCustomScript> converters
    conversion.for("upcast").elementToElement({
      model: "inlineAdvertisementCustomScript",
      view: {
        name: "p",
        classes: "inline-advertisement-custom-script",
      },
    })
    conversion.for("dataDowncast").elementToElement({
      model: "inlineAdvertisementCustomScript",
      view: {
        name: "p",
        classes: "inline-advertisement-custom-script",
      },
    })
    conversion.for("editingDowncast").elementToElement({
      model: "inlineAdvertisementCustomScript",
      view: (modelElement, viewWriter) => {
        // Note: You use a more specialized createEditableElement() method here.
        const view = viewWriter.createEditableElement("p", {
          class: "inline-advertisement-custom-script",
        })
        enablePlaceholder({
          view: this.editor.editing.view,
          element: view,
          text: "カスタマイズする場合はここに入力",
        })
        return toWidgetEditable(view, viewWriter)
      },
    })
  }
}
